import { createApiHandler } from './handler';

const paymentMethods = {
  apiClient: null,
  path: '/franchises/payment-methods',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getSetupIntent() {
    try {
      const response = await this.apiClient.get(this.path + `/setup-intent`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async setDefault(form) {
    try {
      const response = await this.apiClient.post(this.path + `/set-default`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default paymentMethods;
